import { useEffect, useState } from 'react';
import { isEmbedMode, startAutoResize, emit } from '../components/ShopifyBridge';

declare const __APP_VERSION__: string;

// App-level embed wiring. When the wizard is loaded inside the Shopify
// iframe it: (1) tags <html data-embed> so CSS can trim standalone-only
// chrome, (2) announces readiness to the parent, (3) streams document
// height to the parent for auto-resize. Standalone mode is untouched.
export function useEmbedBridge(): boolean {
  const [embed] = useState(() => isEmbedMode());

  useEffect(() => {
    if (!embed) return;
    document.documentElement.dataset.embed = '1';
    emit({ type: 'syhouse:ready', version: __APP_VERSION__ });
    const stop = startAutoResize();
    return () => {
      stop();
      delete document.documentElement.dataset.embed;
    };
  }, [embed]);

  return embed;
}
